/**
 * Microsoft Clarity (heatmaps + grabacion de sesiones).
 *
 * Se llama una sola vez desde entry-client -nunca desde entry-server: ese
 * bundle corre en Node durante el prerender de build, y ejecutar esto ahi
 * mandaria una "sesion" fantasma por cada una de las 47 rutas generadas en
 * cada build, sin que haya un usuario real detras.
 *
 * Solo carga en produccion (import.meta.env.PROD). Sin esto, cada `npm run
 * dev` local sumaria sesiones de desarrollo a las metricas reales.
 */

declare global {
  interface Window {
    clarity?: {
      (...args: unknown[]): void;
      q?: unknown[];
    };
  }
}

const CLARITY_PROJECT_ID = "xo066n6vbw";

export function initClarity(): void {
  if (!import.meta.env.PROD) return;
  if (document.querySelector('script[data-clarity="true"]')) return;

  window.clarity =
    window.clarity ||
    function (...args: unknown[]) {
      (window.clarity!.q = window.clarity!.q || []).push(args);
    };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  script.dataset.clarity = "true";

  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode!.insertBefore(script, firstScript);
}
